module.exports = __webpack_public_path__ + "static/web_identify travel patterns.90d0c8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/web_identify travel patterns.png
// module id = 719
// module chunks = 154382131621592